import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLightBulb"><Path d="M12 1C7.58172 1 4 4.58172 4 9C4 10.8924 4.65734 12.6309 5.75483 14H18.2452C19.3427 12.6309 20 10.8924 20 9C20 4.58172 16.4183 1 12 1Z" fill="currentColor"/><Path d="M8 19V16H16V19H8Z" fill="currentColor"/><Path d="M16 22V20H8V22H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightBulb;
